import LineIcon from '@/components/icons/LineIcon'
import  { useCallback, useEffect, } from 'react'
import { useLayoutContext } from '@/common/context/useLayoutContext'
import { debounce } from 'lodash'
import useViewPort from '@/common/hooks/useViewPort'

const LeftSideBarToggle = () => {
  const {
    menu: { size },
    changeMenu: { size: changeMenuSize },
    toggleBackdrop,
  } = useLayoutContext()

  const handleMenuSize = () => {
    if (size === 'hidden') toggleBackdrop()
    if (size === 'condensed') changeMenuSize('default')
    else if (size === 'default') changeMenuSize('condensed')
  }


  const { width } = useViewPort()

  const resize = useCallback(
    debounce(() => {

      if (width <= 1140) {
        if (size !== 'hidden') changeMenuSize('hidden')
      } else {
        if (size !== 'default') changeMenuSize('default')
      }
    }, 500),
    [width]
  );

  useEffect(() => {
    resize();
    window.addEventListener('resize', resize);
    return () => window.removeEventListener('resize', resize);
  }, [resize]);

  return (
    <div className="topbar-item">
      <button
        type="button"
        onClick={handleMenuSize}
        className="button-toggle-menu pz-icon-btn"
        aria-label={size === 'condensed' ? 'Expand sidebar' : 'Collapse sidebar'}
        aria-expanded={size !== 'condensed' && size !== 'hidden'}
      >
        <LineIcon name="menu" size={20} />
      </button>
    </div>
  )
}

export default LeftSideBarToggle
